const landingTypesList = ['/', '/fullPrice'];

export default landingTypesList;
